import { createFileRoute } from "@tanstack/react-router";
import { CalendarScreen } from "../components/settings/calendar-screen.tsx";
import { SettingsLoading } from "../components/settings/shell.tsx";
import { useSettingsFranchise } from "../components/settings/use-settings-franchise.ts";

export const Route = createFileRoute("/installningar/kalender")({ component: Screen });

function Screen() {
  const franchise = useSettingsFranchise();
  if (franchise === null) return <SettingsLoading />;
  return <CalendarScreen franchiseId={franchise.id} />;
}
